import { BrandInformation } from '@nemuru-eng/js-api-client';

import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

interface MerchantBrandingFormProps extends FormGridOptions {
  brandInformation?: BrandInformation;
}

export const MerchantBrandingForm = ({ brandInformation, fullWidth, fieldVariant }: MerchantBrandingFormProps) => {
  return (
    <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth}>
      <TextFormField label={'BRAND_NAME'} value={brandInformation?.brandName} name={'brandName'} />
      <TextFormField
        label={'CUSTOMER_SUPPORT_EMAIL'}
        value={brandInformation?.customerSupportEmail}
        name={'customerSupportEmail'}
      />
      <TextFormField
        label={'CUSTOMER_SUPPORT_PHONE_NUMBER'}
        value={brandInformation?.customerSupportPhoneNumber}
        name={'customerSupportPhoneNumber'}
      />
      <TextFormField
        label={'HOMEPAGE_URL'}
        value={brandInformation?.homepageUrl}
        name={'homepageUrl'}
        boxProps={{ py: '4px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}
      />
    </FormGridContainer>
  );
};
